import { z, ZodSchema } from "zod";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@core/services/api/formatFirebaseError";
import { loginUser } from "../utils/loginUser";

type Args = {
  onSuccess?: (data: any) => void;
  schema: ZodSchema;
  onError?: (error: Error) => void;
};

export function useLoginMutation({ onSuccess, schema, onError }: Args) {
  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return await loginUser({ data, onError });
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: (data) => {
      // submit callback
      onSuccess?.(data);
    },
  });
}

export default useLoginMutation;
